import axios from "axios";
import { API_HOST } from "@/core/variables";
import { ApiResponse } from "@/model";


class ApiTokenRepository {
    read = async (): Promise<ApiResponse<{token: string}>> => {
        return await axios
            .get(`${API_HOST}/token`)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    refresh = async (): Promise<ApiResponse<{token: string}>> => {
        return await axios
            .post(`${API_HOST}/token/refresh`)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };
}

const apiTokenRepository = new ApiTokenRepository();

export default apiTokenRepository;
